//import '../styles/Banner.css'

function Banner({ children }) {
	return <div className='ljv-banner'>{children}</div>
}

export default Banner
